import { Config } from './config';

export class PortalEnv {
    private static googleApiKey = Config.portal?.googleMapAPIKey ? Config.portal?.googleMapAPIKey :"AIzaSyC4azfkWH233PFGoizTQq4JBPbEPGC1HKU";
    public static getGApiKey() {
        return this.googleApiKey;
    }
}